var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_123_5434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0002 7H12.0002V1H8.00023V7H5.00023L10.0002 12L15.0002 7ZM19.3382 13.532C19.1282 13.308 17.7272 11.809 17.3272 11.418C17.0469 11.1493 16.6735 10.9995 16.2852 11H14.5282L17.5922 13.994H14.0482C14.0001 13.9931 13.9525 14.0049 13.9104 14.0283C13.8682 14.0516 13.833 14.0857 13.8082 14.127L12.9922 16H7.00822L6.19222 14.127C6.16729 14.0858 6.13202 14.0519 6.08992 14.0286C6.04782 14.0052 6.00035 13.9933 5.95223 13.994H2.40823L5.47123 11H3.71522C3.31822 11 2.93923 11.159 2.67323 11.418C2.27323 11.81 0.872225 13.309 0.662225 13.532C0.173225 14.053 -0.0957749 14.468 0.0322251 14.981L0.593225 18.055C0.721225 18.569 1.28423 18.991 1.84523 18.991H18.1572C18.7182 18.991 19.2812 18.569 19.4092 18.055L19.9702 14.981C20.0962 14.468 19.8282 14.053 19.3382 13.532Z",
    fill: "#089D49"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_123_5434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.aa54d12e91273169a00f102d10c745a5.svg";
export { ForwardRef as ReactComponent };